import { css, SerializedStyles } from '@emotion/react';

export const useOfferScheduleFormStyles = (): SerializedStyles => css`
  .schedule-row {
    padding-right: 40px;
    position: relative;

    .MuiIconButton-root {
      height: 21px;
    }
  }
  .schedule-delete-btn {
    position: absolute;
    right: -5px;
    top: 10px;
  }
`;
